"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KsysRequest_1 = require("../KsysRequest");

var GetApplicationAppConfig =
/** @class */
function (_super) {
  __extends(GetApplicationAppConfig, _super);

  function GetApplicationAppConfig() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getExplicitEndpoint = function () {
      return '/getApplicationAppConfig';
    };

    _this.getExplicitMethod = function () {
      return 'GET';
    };

    return _this;
  }

  Object.defineProperty(GetApplicationAppConfig.prototype, "endpointConfiguration", {
    get: function get() {
      return this.getEndpointConfiguration("root", "GetApplicationAppConfig");
    },
    enumerable: true,
    configurable: true
  });
  return GetApplicationAppConfig;
}(KsysRequest_1.KsysRequest);

exports.GetApplicationAppConfig = GetApplicationAppConfig;